import { get, post, put, patch } from 'api/request';
import urls from 'configs/urls';

export const getAllOrders = data =>
  get(null, false, urls.labsModuleUrls.ordersUrls.getAllOrders, data);

export const getOrderDetails = ({ orderId, data }) =>
  get(null, false, `${urls.labsModuleUrls.ordersUrls.getOrderDetails}/${orderId}`, data);

export const getOrderPatientUserDetails = ({ patientUserKey }) =>
  get(
    null,
    false,
    `${urls.labsModuleUrls.ordersUrls.getOrderPatientUserDetails}/${patientUserKey}`,
  );

export const assignOrderToEntity = ({ data }) =>
  post(null, false, urls.labsModuleUrls.ordersUrls.assignOrderToEntity, data);

export const updateOrderServices = ({ orderId, data }) =>
  put(
    null,
    false,
    `${urls.labsModuleUrls.ordersUrls.getOrderDetails}/${orderId}/invoice`,
    data.orderServices,
  );

export const updateOrderStatus = ({ data }) =>
  post(null, false, urls.labsModuleUrls.ordersUrls.updateOrderStatus, data);

export const updateOrderNote = ({ orderId, data }) =>
  patch(null, false, `${urls.labsModuleUrls.ordersUrls.updateOrderNote}/${orderId}`, data);

export const scheduleOrder = ({ orderId, data }) =>
  post(null, false, `${urls.labsModuleUrls.ordersUrls.scheduleOrder}/${orderId}/status`, data);

export const getScheduleOrderReasons = () =>
  get(null, false, `${urls.labsModuleUrls.ordersUrls.orderStateReasonsTree}?stateId=38`);

export const getCancelOrderReasons = () =>
  get(null, false, `${urls.labsModuleUrls.ordersUrls.orderStateReasonsTree}?stateId=37`);
